// extracted by mini-css-extract-plugin
export var csatScore = "_ne-5";
export var header = "_ne-1";
export var panelWrapper = "_ne-2";
export var postPreview = "_ne-3";
export var rightContent = "_ne-0";
export var wrappingText = "_ne-4";